export default {
  methods: {
    async sendSlipByEmailAnticipation(item, email, fromHome = false) {
      return await this.$store.dispatch('solicitations/sendSlipByEmail', {
        item,
        email,
        mode: 'anticipation',
        fromHome,
      });
    },
    async sendSlipBySmsAnticipation(item, cellphone, fromHome = false) {
      return await this.$store.dispatch('solicitations/sendSlipBySms', {
        item,
        cellphone,
        mode: 'anticipation',
        fromHome,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/anticipationPaymentSlip.js